








































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import TplDetail from "@/store/entities/tpls/tpl-detail";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";

@Component
export default class ViewTpl extends mixins(DateTimeMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  tpl: TplDetail = new TplDetail();
  spinShow = false;
  code: string = "";
  get isTpl() {
    return (
      !_.isNil(this.tpl) && !_.isNil(this.tpl.type) && this.tpl.type === "TPL"
    );
  }
  get isVehicle() {
    return (
      !_.isNil(this.tpl) &&
      !_.isNil(this.tpl.type) &&
      this.tpl.type === "VEHICLE"
    );
  }
  async getInfo() {
    await this.$store
      .dispatch({
        type: "tpl/get",
        data: {
          id: this.code,
        },
      })
      .then((res) => {
        this.tpl = res;
      });
  }
  cancel() {
    (this.$refs.tplForm as any).resetFields();
    this.$root.$router.push({ name: "tpl" });
  }
  async created() {
    this.spinShow = true;
    try {
      this.code = this.$root.$router.currentRoute.params.code;
      await this.getInfo();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
}
